import gql from "graphql-tag";

export default gql`
  mutation CreateCustomer(
    $name: String!
    $address: String
    $email: String!
    $phoneNumber: String
    $customerRequestCode: String
    $companyId: ID!
  ) {
    createCustomer(
      name: $name
      address: $address
      email: $email
      phoneNumber: $phoneNumber
      customerRequestCode: $customerRequestCode
      companyId: $companyId
    ) {
      id
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Mutations/CreateCustomer.ts